export default __webpack_public_path__ + "static/media/263.cd8f5a5a.png";